/**
 * Component that checks the authentication status and renders different content based on the status.
 * If the user is logged in, it renders the Layout component.
 * If the authentication status is still loading, it renders a loading message.
 * If the user is not logged in, it navigates to the login page.
 */
import { Box } from "@mui/material";
import { Navigate } from "react-router-dom";

import { Layout } from "./components/Layout";
import { useAppSelector } from "./redux/store";
import { Loader } from "./shared/Loader";

export const PasswordSetCheck = () => {
	const {
		authStatus,
		isPasswordSet,
		isMultiFactorAuthSet,
	} = useAppSelector((state) => state.user);

	if (
		authStatus.isLoggedIn &&
		isPasswordSet &&
		isMultiFactorAuthSet
	) {
		return <Layout />;
	}

	if (authStatus.isLoggedIn && !isPasswordSet) {
		return <Navigate to="/create-password" />;
	}

	if (
		authStatus.isLoggedIn &&
		isPasswordSet &&
		!isMultiFactorAuthSet
	) {
		return <Navigate to="/multi-factor-verification" />;
	}

	if (!authStatus.isLoading) {
		return <Navigate to="/login" />;
	}

	return (
		<Box>
			<Box className={"page-loader"}>
				<Loader />
			</Box>
		</Box>
	);
};
